import { Component, inject, output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PopoverDirective } from "@kno2/common/directives";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { TOOLTIP_KNOWLEDGE_BASE } from "../support.constants";

@Component({
    selector: "kno2-support-knowledge-base",
    imports: [PopoverDirective],
    templateUrl: "./support.knowledge-base.component.html"
})
export class SupportKnowledgeBaseComponent {
    private readonly route = inject(ActivatedRoute);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    protected readonly tooltip = TOOLTIP_KNOWLEDGE_BASE;
    protected expanded: boolean;
    protected brandDisplayName: string;
    protected knowledgeBaseUrl: string;
    protected readonly toggleCollapse = output<void>();

    public ngOnInit(): void {
        this.expanded = this.route.snapshot.routeConfig.path.endsWith("knowledge");
        this.brandDisplayName = this.appConfig.brandDisplayName;
        this.knowledgeBaseUrl = this.appConfig.knowledgeBaseUrl;
    }
}
